import { styled } from 'ui';

export const LoaderContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  left: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
});

export const CanvasContainer = styled('div')(() => ({
  textAlign: 'center',
}));

export const PositioningBase = styled('div')(() => ({
  display: 'inline-block',
  position: 'relative',
}));

export const Canvas = styled('canvas')<{
  giveFeedback: boolean;
  isLoading: boolean;
}>(({ giveFeedback, isLoading }) => ({
  cursor: giveFeedback ? 'context-menu' : 'default',
  display: 'block',
  height: 'auto',
  margin: '0 auto',
  maxHeight: 'inherit',
  maxWidth: '100%',
  opacity: isLoading ? 0.3 : 1,
  touchAction: 'pan-y',
  transition: 'opacity 0.3s ease-in-out',
}));
